var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13217_120271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4083 3.17958C13.392 3.07633 13.2263 2.14883 12.5543 1.47158C11.8794 0.811249 10.9484 0.647915 10.8445 0.631582C10.7063 0.608832 10.5651 0.637999 10.4467 0.711499C10.3779 0.754082 8.72354 1.79008 5.36471 5.125C1.82796 8.63725 0.900458 10.0407 0.862542 10.0985C0.809458 10.1802 0.777375 10.2741 0.769792 10.3709L0.583708 12.7457C0.570875 12.916 0.632125 13.0828 0.752875 13.2036C0.862542 13.3132 1.01129 13.3745 1.16587 13.3745C1.18046 13.3745 1.19562 13.3745 1.21079 13.3727L3.60304 13.1884C3.69929 13.1808 3.79204 13.1499 3.87312 13.098C3.93146 13.0607 5.34487 12.1396 8.88104 8.6285C12.2405 5.293 13.284 3.64975 13.3272 3.5815C13.4019 3.46192 13.431 3.319 13.4089 3.17958H13.4083ZM8.05913 7.80075C5.18329 10.6562 3.74596 11.7557 3.35512 12.0375L1.80054 12.1577L1.92071 10.6223C2.20771 10.2303 3.31662 8.80292 6.18604 5.95333C7.07446 5.07133 7.84038 4.35442 8.48554 3.77808C8.49138 3.77925 8.49721 3.78042 8.50363 3.78158C8.51063 3.78275 9.22521 3.90641 9.68254 4.35325C10.1329 4.79366 10.2595 5.47908 10.263 5.496C10.263 5.49833 10.2641 5.50008 10.2641 5.50241C9.68138 6.14583 8.95454 6.91175 8.05913 7.80075ZM11.156 4.48508C11.0166 4.17358 10.8078 3.82125 10.4986 3.51908C10.193 3.21983 9.83713 3.01683 9.52213 2.8815C10.1865 2.32733 10.6351 1.99717 10.869 1.83325C11.1135 1.90558 11.481 2.05317 11.733 2.29992C11.9972 2.56592 12.1384 2.9305 12.2055 3.15683C12.0392 3.39017 11.709 3.83292 11.1566 4.48567L11.156 4.48508Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13217_120271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.916ef1ac786e1136965dd2a0b7128b75.svg";
export { ForwardRef as ReactComponent };